import {AdditivesForClinkerClassificationInputNames, MaterialType} from '@domain/materials'

import {useMaterialsClassificationMetadata} from '../../../hooks/queries'
import {MaterialsGrid} from '../components/MaterialsGrid'
import {MaterialsGridItem} from '../components/MaterialsGridItem'

import {ClassificationAutocomplete} from './inputs/ClassificationAutocomplete'
import {ClassificationTextField} from './inputs/ClassificationTextField'

interface AdditivesForClinkerClassificationProps {
  isDisabled: boolean
}

export const AdditivesForClinkerClassification: React.FC<
  AdditivesForClinkerClassificationProps
> = ({isDisabled}) => {
  const {data: additivesForClinkerClassificationMetadata} = useMaterialsClassificationMetadata(
    MaterialType.AdditivesForClinker
  )
  if (!additivesForClinkerClassificationMetadata) {
    throw new Error(
      'BUG: classification metadata should be loaded before rendering classification tab'
    )
  }

  return (
    <MaterialsGrid>
      <MaterialsGridItem>
        <ClassificationAutocomplete
          materialType={MaterialType.AdditivesForClinker}
          inputName={AdditivesForClinkerClassificationInputNames.Category}
          metadata={additivesForClinkerClassificationMetadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationTextField
          materialType={MaterialType.AdditivesForClinker}
          inputName={AdditivesForClinkerClassificationInputNames.LegacyId}
          metadata={additivesForClinkerClassificationMetadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
    </MaterialsGrid>
  )
}
